// extracted by mini-css-extract-plugin
export default {"root":"styles_root__veyCb","fadeIn":"styles_fadeIn__6QHJ+","inner":"styles_inner__eNRIF"};